module.exports = __webpack_public_path__ + "media/click.73e0a0b0.wav";